(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/game-results/assets/javascripts/utils.js') >= 0) return;  svs.modules.push('/modules/game-results/assets/javascripts/utils.js');

'use strict';

const calcAvailableHeight = () => {
  const header = document.querySelector('header');
  let availableHeight = 0;
  if (header && header.offsetHeight) {
    availableHeight = window.innerHeight - (header.offsetHeight + header.getBoundingClientRect().top + $(window).scrollTop());
  }
  return availableHeight;
};
svs.game_results.utils = {
  calcAvailableHeight
};

 })(window);